export class Session {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "appName",
            "baseName": "app_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "lastUpdateTime",
            "baseName": "last_update_time",
            "type": "number",
            "format": ""
        },
        {
            "name": "events",
            "baseName": "events",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Session.attributeTypeMap;
    }
    constructor() {
    }
}
